import React from "react";
import Meme from "./Meme";

export default function Main() {
    return(
        <div className="w-full px-[15px] pt-[20px] pb-[30px] sm:p-[36px] bg-white shadow-md rounded-b-md">
            <Meme/>
        </div>
    )
}